import { ApartmentCountLimits } from '../ApartmentCountLimits';
import { GoogleTagEventKeys } from '../GoogleTagEventKeys';
import { TrackGoogleEventUseCase } from '../../application/use_cases/analytics/TrackGoogleEventUseCase';
import { ApartmentCountLimitUseCase } from '../../application/use_cases/apartment_count/ApartmentCountLimitUseCase';
import { EnvironmentPort } from '../../application/ports/environment/EnvironmentPort';
import { NodeEnvironmentAdapter } from '../../frameworks_drivers/NodeEnvironmentAdapter';
import { ConsoleLogger } from '../../frameworks_drivers/logging/ConsoleLogger';

export const consoleLogger = new ConsoleLogger();

const environmentService: EnvironmentPort = new NodeEnvironmentAdapter(consoleLogger);
// Ports

// Use Cases
export const trackGoogleEventUseCase = new TrackGoogleEventUseCase(new GoogleTagEventKeys());
export const apartmentCountLimitUseCase = new ApartmentCountLimitUseCase(
  new ApartmentCountLimits()
);

export { environmentService };
